module.exports = __webpack_public_path__ + "img/not_found_blog.8516fbb4.svg";